import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { Box, Text, Flex, Button } from '@chakra-ui/react';
import { format } from 'date-fns';
import pl from 'date-fns/locale/pl';

const DateRangeSelector = ({ label, fromDate, toDate, onChange }) => {
    const [from, setFrom] = useState(fromDate || null);
    const [to, setTo] = useState(toDate || null);

    const formatDate = (date) => (date ? format(date, 'dd.MM.yyyy') : 'Od');

    return (
        <Flex alignItems={"center"} gap="16px">
            <Text whiteSpace="nowrap">{label}:</Text>
            <DatePicker
                selected={from}
                onChange={(date) => {
                    setFrom(date);
                    onChange({ from: date, to });
                }}
                locale={pl}
                customInput={
                    <Button variant="link" fontWeight="bold" color="brand.500" gap="10px">
                        {formatDate(from)}
                        <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0.5L10 4.08481L5 8.5L-1.56697e-07 4.08481L0 0.5L5 4.93544L10 0.5Z" fill="#5C1628"/>
                        </svg>
                    </Button>
                }
            />
            <DatePicker
                selected={to}
                onChange={(date) => {
                    setTo(date);
                    onChange({ from, to: date });
                }}
                locale={pl}
                customInput={
                    <Button variant="link" fontWeight="bold" color="brand.500" gap="10px">
                        {to ? format(to, 'dd.MM.yyyy') : 'Do'}
                        <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0.5L10 4.08481L5 8.5L-1.56697e-07 4.08481L0 0.5L5 4.93544L10 0.5Z" fill="#5C1628"/>
                        </svg>
                    </Button>
                }
            />
        </Flex>
    );
};

export default DateRangeSelector;
